import * as S from "./ExerciseStateItem.style";
import { ReactComponent as IconFire } from "@/styles/assets/svg/icon_fire.svg";
import { ReactComponent as IconCheckCircle } from "@/styles/assets/svg/icon_check_circle.svg";
import { ReactComponent as IconEmptyCircle } from "@/styles/assets/svg/icon_empty_circle.svg";

interface ExerciseStateItemProps {
  type?: "state" | "bonus";
  title?: string;
  data?: any;
}

export const ExerciseStateItem = ({
  type,
  title,
  data,
}: ExerciseStateItemProps) => {
  const participationData = Array.from({ length: 12 }, (_, i) => (i + 1) * 3);
  const filledBoxCount = data ? Math.floor(data.exerciseComplete / 3) : 0;

  if (!data) return null;

  return (
    <S.ExerciseStateBox>
      <S.ExerciseStateTit>{title}</S.ExerciseStateTit>

      {type === "state" ? (
        <S.ItemBox>
          <S.ItemHeader>
            <S.HeaderTit>
              나의 운동 프로그램 참여
              {data?.exerciseComplete > 0 ? (
                <S.PartCount>
                  <IconFire /> 누적 참여 {data.exerciseComplete}회차
                </S.PartCount>
              ) : (
                <></>
              )}
            </S.HeaderTit>
          </S.ItemHeader>

          <S.ItemSub $shade={true}>
            <S.ItemSubHeader>
              <S.ItemSubTit>
                추가 운동 참여 <span>(신체 건강/부위별)</span>
              </S.ItemSubTit>
            </S.ItemSubHeader>

            {data.dayExerciseCount > 0 ? (
              <S.DayExerciseComplete $type="complete">
                완료
                <IconCheckCircle />
              </S.DayExerciseComplete>
            ) : (
              <S.DayExerciseComplete $type="incomplete">
                미완료
                <IconEmptyCircle />
              </S.DayExerciseComplete>
            )}
          </S.ItemSub>
        </S.ItemBox>
      ) : (
        <S.ItemBox>
          <S.ParticipationContainer>
            <S.ItemHeader>
              <S.HeaderTit>나의 운동 프로그램 누적 참여</S.HeaderTit>
            </S.ItemHeader>

            <S.Participation>
              {participationData.map((num, index) => {
                const isFilled = index < filledBoxCount;
                return (
                  <S.CumulativeParticipationBox key={num} isFilled={isFilled}>
                    <span>{num}회차</span>
                    <div>
                      {isFilled ? (
                        <IconCheckCircle width={23} height={23} />
                      ) : (
                        <IconEmptyCircle />
                      )}
                    </div>
                  </S.CumulativeParticipationBox>
                );
              })}
            </S.Participation>
          </S.ParticipationContainer>

          <S.ItemSubBox>
            <S.ItemSub>
              <S.ItemHeader>
                <S.HeaderTit>18회차 달성</S.HeaderTit>
              </S.ItemHeader>
              {data.exerciseComplete >= 18 ? (
                <S.ItemCompleteCircle>
                  완료!
                  <IconCheckCircle />
                </S.ItemCompleteCircle>
              ) : (
                <S.ItemNotCompleteCircle>
                  미완료
                  <IconEmptyCircle />
                </S.ItemNotCompleteCircle>
              )}
            </S.ItemSub>
            <S.ItemSub>
              <S.ItemHeader>
                <S.HeaderTit>36회차 달성</S.HeaderTit>
              </S.ItemHeader>
              {data.exerciseComplete >= 36 ? (
                <S.ItemCompleteCircle>
                  완료!
                  <IconCheckCircle />
                </S.ItemCompleteCircle>
              ) : (
                <S.ItemNotCompleteCircle>
                  미완료
                  <IconEmptyCircle />
                </S.ItemNotCompleteCircle>
              )}
            </S.ItemSub>
          </S.ItemSubBox>
        </S.ItemBox>
      )}
    </S.ExerciseStateBox>
  );
};
